/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    fork, put, call, select,
} from 'redux-saga/effects';

import { getOrderId } from '../../../../Checkout/ducks/Common/Common-Selectors';

import takeLeading from '../../../../../../app/helpers/sagas/takeLeading';
import memberDucks from '../../../../Member/ducks';

import { clearOrderItemErrors } from '../../../../Checkout/ducks/Common/ducks/Error/Error-Actions';
import updatePersonalization from './Personalization-Actions';
import { processFeatureErrors } from '../../../../Checkout/ducks/Common/ducks/Error/Error-Operations';
import updatePersonalizationLines from '../../../../../../apis/cart-service-apis/updatePersonalizationLines';
import { PERSONALIZATION } from '../../../../../utils/errorFeatureTypes';
import { retrieveCart } from '../../Cart/ducks/RetrieveCart/RetrieveCart-Operations';

const {
    auth: {
        authOperations,
    },
} = memberDucks;

const { checkJWT } = authOperations.workers;

function* workerUpdatePersonalization(action) {
    const cartId = yield select(getOrderId);
    yield put(clearOrderItemErrors(
        cartId,
        PERSONALIZATION,
        { errType: 'clearAllFields', field: '' },
    ));
    try {
        const jwtToken = yield call(checkJWT);
        const personalizationLines = action?.data?.personalization?.personalizationLines;

        const reqObj = {
            env: {},
            jwtToken,
            cartId,
            cartItemId: action.data.orderItemId,
            personalizationLines,
        };

        const response = yield call(updatePersonalizationLines, reqObj);

        if (response?.data?.result === 'SUCCESS' && action?.data?.handleCallback) {
            yield call(action.data.handleCallback, false);
            yield call(retrieveCart);
        }
    } catch (ex) {
        yield fork(processFeatureErrors, {
            data: {
                orderItemId: action.data.orderItemId,
                errorFeatureType: PERSONALIZATION,
                errorValues: { errorKey: 'UPDATE_PERSONALIZATION_ERROR', errorMessage: 'There was an issue with updating' },

            },
        });
    }
}

function* watchUpdatePersonalization() {
    yield takeLeading(updatePersonalization().type, workerUpdatePersonalization);
}

const watchers = [
    fork(watchUpdatePersonalization),
];

export { watchers };

export default {};
